import { Modal, message } from "antd"
import { useEffect, useState } from "react"
import { BottomBtn } from "../../../../../shared"
import { WellnessLectureInfoRow } from "../../lectureInfoRow";
import { lectureDatePeriodFormat } from "../../../../../utils";
import dayjs from "dayjs";
import { cancelReservationByMemberIdAndReservationId } from "../../../../../service";

interface IProps {
    wellnessLecture: IWellnessLectureDetailWebResponseV2
    requestWellnessLectureById: Function
}
const CancelReservationWithModalInWellnessLectureDetail = ({ wellnessLecture, requestWellnessLectureById }: IProps) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [isRequestCancel, setIsRequestCancel] = useState<boolean>(false)
    const [isCancelDisableModalOpen, setIsCancelDisableModalOpen] = useState<boolean>(false);
    const [isCancelCompleteModalOpen, setIsCancelCompleteModalOpen] = useState<boolean>();

    message.config({ top: 200 })

    const clickCancelReservation = async () => {
        if (!wellnessLecture || !wellnessLecture.reservationId) return;

        if (dayjs().isAfter(dayjs(wellnessLecture.wellnessLectureStartDateTime).add(-3, 'h'))) {
            setIsOpen(false);
            setIsCancelDisableModalOpen(true);
            return;
        }

        setIsOpen(false);
        try {
            setIsRequestCancel(true)
            const res = await cancelReservationByMemberIdAndReservationId(wellnessLecture.reservationId)
            if (["중이라 취소 할 수 없습니다.", "3시간 이전에만 취소가 가능합니다."].some(checkString => res.data.includes(checkString))) {
                message.error(res.data)
            } else {
                setIsCancelCompleteModalOpen(true);
            }
        } catch (error) {
            console.error('error', error)
        } finally { setIsRequestCancel(false) }
    }

    const onClickSuccessCancelReservation = () => {
        setIsCancelCompleteModalOpen(false);
    }
    useEffect(() => {
        if (isCancelCompleteModalOpen === false)
            requestWellnessLectureById()
    }, [isCancelCompleteModalOpen])
    return <>
        <BottomBtn
            onClick={() => setIsOpen(isOpen ? false : true)}
            text={isRequestCancel ? "취소 중" : "취소하기"} />

        <Modal
            centered
            open={isOpen}
            onCancel={() => setIsOpen(false)}
            footer={null}>
            <div>
                <div className="sub-title/st3" style={{ paddingBlock: 6 }}>예약을 취소할까요?</div>
                <div className="body/b1 secondary/s800">취소하려는 예약 내역을 다시 확인해 보세요.</div>
            </div>

            <div style={{ marginTop: 16, padding: 12, backgroundColor: 'var(--secondarys100)', color: 'var(--secondarys700)' }}>
                <WellnessLectureInfoRow label="시간" value={lectureDatePeriodFormat(wellnessLecture.wellnessLectureStartDateTime, wellnessLecture.wellnessLectureEndDateTime)} />
                <WellnessLectureInfoRow label="장소" value={`${wellnessLecture.yogaCenterName} ${wellnessLecture.room}`} />
                <WellnessLectureInfoRow label="코치" value={`${wellnessLecture.teacherName} 코치`} />
                {!!wellnessLecture.guestCount && <WellnessLectureInfoRow label="인원" value={`${wellnessLecture.guestCount + 1}명 (게스트 ${wellnessLecture.guestCount}명)`} />}
            </div>
            {!!wellnessLecture.guestCount && <div className="body/b2 secondary/s700" style={{ marginTop: 12 }}>
                게스트 예약도 함께 취소되며, 사용한 {wellnessLecture.guestCount + 1}회가 모두 복구됩니다.
            </div>}

            <div
                className="sub-title/st3"
                style={{ border: '1px solid var(--secondarys500)', borderRadius: 'var(--radius4)', color: 'var(--secondarys500)', padding: '12px', textAlign: 'center', marginTop: '15px', cursor: 'pointer' }}
                onClick={() => clickCancelReservation()}>예약 취소하기</div>
        </Modal>

        <Modal centered open={isCancelDisableModalOpen} onCancel={() => setIsCancelDisableModalOpen(false)} footer={[]}>
            <div>
                <div className="sub-title/st3" style={{ paddingBlock: 6 }}>예약을 취소할 수 없습니다</div>
                <div className="body/b1 secondary/s800">수업 시작 3시간 이전에만 취소가 가능합니다.</div>
            </div>
            <div className="sub-title/st3"
                style={{ backgroundColor: 'white', border: '1px solid #555', color: 'black', padding: '15px', borderRadius: '5px', textAlign: 'center', marginTop: '15px', cursor: 'pointer' }}
                onClick={() => setIsCancelDisableModalOpen(false)}>돌아가기</div>
        </Modal>

        <Modal centered open={isCancelCompleteModalOpen} onCancel={() => setIsCancelCompleteModalOpen(false)} footer={[]}>
            <div>
                <div className="sub-title/st3" style={{ paddingBlock: 6 }}>예약 취소 완료</div>
                <div className="body/b1 secondary/s800">취소가 완료되었습니다.</div>
            </div>

            <div style={{ marginTop: 16, padding: 12, backgroundColor: 'var(--secondarys100)', color: 'var(--secondarys700)' }}>
                <WellnessLectureInfoRow label="시간" value={lectureDatePeriodFormat(wellnessLecture.wellnessLectureStartDateTime, wellnessLecture.wellnessLectureEndDateTime)} />
                <WellnessLectureInfoRow label="장소" value={`${wellnessLecture.yogaCenterName} ${wellnessLecture.room}`} />
                <WellnessLectureInfoRow label="코치" value={`${wellnessLecture.teacherName} 코치`} />
            </div>

            <div style={{ backgroundColor: 'black', color: 'white', padding: '15px', borderRadius: '5px', textAlign: 'center', fontSize: '15px', marginTop: '15px', cursor: 'pointer' }}
                onClick={() => onClickSuccessCancelReservation()}>닫기</div>
        </Modal>
    </>
}

export { CancelReservationWithModalInWellnessLectureDetail }